import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  Menu as MenuIcon,
  FilterAlt,
  PointOfSale,
  Receipt,
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';

const MOBILE_HEADER_HEIGHT = 56;

const getPageTitle = (pathname) => {
  if (pathname.startsWith('/pos')) return 'Punto de Venta';
  if (pathname.startsWith('/billing')) return 'Facturación';
  if (pathname === '/inventory') return 'Inventario';
  if (pathname === '/customers') return 'Clientes';
  if (pathname === '/suppliers') return 'Proveedores';
  if (pathname === '/settings') return 'Configuración';
  return 'NX2026';
};

const getPageIcon = (pathname) => {
  if (pathname.startsWith('/pos')) return <PointOfSale />;
  if (pathname.startsWith('/billing')) return <Receipt />;
  return null;
};

const MobileHeader = ({ onMenuClick, onFilterClick, showFilter = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();

  // Solo mostrar en móvil
  if (!isMobile) return null;

  const pageTitle = getPageTitle(location.pathname);
  const pageIcon = getPageIcon(location.pathname);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: MOBILE_HEADER_HEIGHT,
        backgroundColor: 'primary.main',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        px: 1,
        zIndex: 1100,
        boxShadow: 2,
      }}
    >
      {/* Botón de menú hamburguesa */}
      <IconButton
        onClick={onMenuClick}
        sx={{
          color: 'white',
          mr: 1,
          // Touch target mínimo 48x48px
          minWidth: 48,
          minHeight: 48,
        }}
        aria-label="Abrir menú"
      >
        <MenuIcon />
      </IconButton>

      {/* Título de la página */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
        {pageIcon && (
          <Box sx={{ color: 'white', display: 'flex', alignItems: 'center' }}>
            {pageIcon}
          </Box>
        )}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            fontSize: '1.1rem',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {pageTitle}
        </Typography>
      </Box>

      {/* Botón de filtros (si es necesario) */}
      {showFilter && (
        <IconButton
          onClick={onFilterClick}
          sx={{
            color: 'white',
            // Touch target mínimo 48x48px
            minWidth: 48,
            minHeight: 48,
          }}
          aria-label="Filtros"
        >
          <FilterAlt />
        </IconButton>
      )}
    </Box>
  );
};

export default MobileHeader;

// Constante exportada para uso en otros componentes
export { MOBILE_HEADER_HEIGHT };
